"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const appConstants_1 = require("../../../constants/appConstants");
const StyledBox_1 = require("../../../material-ui-theme/components/styled/StyledBox");
const sessionQuery_1 = require("../../../queries/sessionQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const walletQuery_1 = require("../../../queries/walletQuery");
const tableSkeletonLoader_1 = __importDefault(require("../../../router/loaders/tableSkeletonLoader"));
const userSelectors_1 = require("../../../selectors/userSelectors");
const zustandStore_1 = require("../../../zustandStore");
const slices_1 = require("../../../zustandStore/slices");
const cardsSkeletonLoader_1 = __importDefault(require("./component/cardsSkeletonLoader"));
const emptyWallet_1 = __importDefault(require("./emptyWallet/emptyWallet"));
const walletContainer_1 = __importDefault(require("./walletContainer"));
const headerActions_1 = __importDefault(require("./walletHeader/headerActions"));
const walletHelper_1 = require("./walletHelper");
const WalletDetailAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./asides/walletDetailsAside/walletDetailAside'))));
const MyCardsListView = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./myCardsListView'))));
const AmexCardsListView = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./cardsListView/amex'))));
const logger = (0, pino_1.default)();
function TableLoader() {
    return (0, jsx_runtime_1.jsx)(tableSkeletonLoader_1.default, { rows: 3, columns: 8 });
}
const DEFAULT_MYCARDS_LIMIT = 12;
const DEFAULT_CARDS__LIST_LIMIT = 10;
const WalletPage = () => {
    const theme = (0, material_1.useTheme)();
    const location = (0, react_router_1.useLocation)();
    const logout = (0, sessionQuery_1.useSessionLogoutQuery)();
    const { userId: userIdFromUrlParams, teamId: teamIdFromUrlParams } = (0, react_router_1.useParams)();
    const { setTeamFilter, setMemberFilter, setCardStatusFilter, setCurrentWalletPage, setWalletSortValue, setTeamOptions, setMemberOptions, setWalletCards, setHasNextPage, setAreFiltersManuallySet, setHasUserSkipMfa, wallet, } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { teamFilter, memberFilter, cardStatusFilter, sortValue, pager, cards, areFiltersManuallySet } = wallet;
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: selectedTeamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    let owner = initialData.paginatedFilterApiQuery.owner || userIdFromUrlParams || '';
    let teamId = initialData.paginatedFilterApiQuery.teamId || teamIdFromUrlParams || '';
    if (location.pathname === '/wallet' && initialData.userRole === appConstants_1.overviewConstants.COMPANY_ADMIN) {
        owner = memberFilter === 'all' ? '' : memberFilter;
        teamId = teamFilter === 'all' ? '' : teamFilter;
    }
    if (location.pathname.includes('/wallet/my-cards')) {
        owner = initialData.paginatedFilterApiQuery.owner || userIdFromUrlParams || '';
        teamId = '';
    }
    if (location.pathname.includes('/wallet/team')) {
        owner = memberFilter === 'all' ? '' : memberFilter;
        teamId =
            teamFilter === 'all' ? initialData.paginatedFilterApiQuery.teamId || teamIdFromUrlParams || '' : teamFilter;
    }
    const sortValueEntried = Object.entries(sortValue);
    const isMyCardsView = globalThis.location.pathname.includes('/wallet/my-cards');
    const isOtherWalletPagesView = [
        '/wallet/team',
        '/wallet',
        `/wallet/team/${initialData.paginatedFilterApiQuery.teamId || teamIdFromUrlParams}/user/${initialData.paginatedFilterApiQuery.owner || userIdFromUrlParams}`,
    ].some(path => {
        return globalThis.location.pathname.endsWith(path);
    });
    const itemsPerPage = isMyCardsView ? DEFAULT_MYCARDS_LIMIT : DEFAULT_CARDS__LIST_LIMIT;
    const [currentSortKey] = Object.keys(sortValue);
    const newSortValue = {
        [currentSortKey || 'newest']: slices_1.sortWalletOptions[currentSortKey || 'newest'],
    };
    const query = isMyCardsView
        ? {
            ...(0, walletQuery_1.paginatedMyWalletListQuery)({
                limit: itemsPerPage,
                page: pager.currentPage,
                ...initialData.paginatedFilterApiQuery,
                status: cardStatusFilter === 'active' ? 'ACTIVE' : 'INACTIVE',
                sortBy: slices_1.sortWalletMapper[sortValueEntried?.[0]?.[0] || 'CREATION_DATE'],
                sortOrder: slices_1.sortWalletMapper[sortValueEntried?.[0]?.[1] || 'desc'],
                owner,
                teamId,
            }),
            enabled: isMyCardsView,
        }
        : {
            ...(0, walletQuery_1.paginatedWalletListQuery)({
                limit: itemsPerPage,
                page: pager.currentPage,
                ...initialData.paginatedFilterApiQuery,
                status: cardStatusFilter === 'active' ? 'ACTIVE' : 'INACTIVE',
                sortBy: slices_1.sortWalletMapper[sortValueEntried[0]?.[0] || 'CREATION_DATE'],
                sortOrder: slices_1.sortWalletMapper[sortValueEntried[0]?.[1] || 'desc'],
                owner,
                teamId,
            }),
            enabled: isOtherWalletPagesView,
        };
    const { isFetching: isWalletDataFetching, data: paginatedWalletData = { count: 0, tasks: [], initialPaginatedWalletDataCount: 0, hasNextPage: false }, } = (0, react_query_1.useQuery)(query);
    const { data: currentUser } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const isUserCompanyAdminOrSupport = (0, userSelectors_1.isCompanyOrSupportAdmin)(currentUser && currentUser?.roles && currentUser?.roles.length > 0 ? currentUser?.roles : []);
    const { data: filterTeam, refetch: refetchTeamMembers } = (0, react_query_1.useQuery)((0, teamQuery_1.getTeamUsersQuery)({
        teamId: teamFilter === 'all' ? initialData.paginatedFilterApiQuery.teamId || teamIdFromUrlParams || '' : teamFilter,
    }));
    (0, react_1.useEffect)(() => {
        setHasNextPage(paginatedWalletData?.hasNextPage ?? false);
    }, [paginatedWalletData?.hasNextPage]);
    (0, react_1.useEffect)(() => {
        if (!areFiltersManuallySet && (userIdFromUrlParams || teamIdFromUrlParams)) {
            if (userIdFromUrlParams) {
                setMemberFilter(userIdFromUrlParams);
            }
            if (teamIdFromUrlParams) {
                setTeamFilter(teamIdFromUrlParams);
            }
        }
        else if (isMyCardsView && initialData.userRole !== appConstants_1.overviewConstants.COMPANY_ADMIN) {
            if (selectedTeamId) {
                setTeamFilter(selectedTeamId?.[0] || '');
            }
            if (currentUser) {
                setMemberFilter(currentUser?.userId);
            }
            setCardStatusFilter(cardStatusFilter || 'active');
            setWalletSortValue(newSortValue);
            setCurrentWalletPage(pager.currentPage || 0);
        }
        else if (location.pathname.includes('/wallet/team')) {
            const [firstId] = selectedTeamId || [];
            setTeamFilter(teamFilter || firstId || '');
            setMemberFilter(memberFilter || 'all');
            setCardStatusFilter(cardStatusFilter || 'active');
            setWalletSortValue(newSortValue);
            setCurrentWalletPage(pager.currentPage || 0);
        }
        else if (location.pathname === '/wallet' && initialData.userRole === appConstants_1.overviewConstants.COMPANY_ADMIN) {
            setTeamFilter(teamFilter || 'all');
            setMemberFilter(memberFilter || 'all');
            setCardStatusFilter(cardStatusFilter || 'active');
            setWalletSortValue(newSortValue);
            setCurrentWalletPage(pager.currentPage || 0);
        }
        else if (location.pathname.includes('/wallet') && initialData.userRole !== appConstants_1.overviewConstants.COMPANY_ADMIN) {
            // TODO: this breaks navigating to new requests page
            // navigate('/wallet/my-cards');
        }
        return () => {
            if (setAreFiltersManuallySet) {
                setAreFiltersManuallySet(false);
            }
        };
    }, [
        currentUser,
        initialData.userRole,
        isMyCardsView,
        location.pathname,
        memberFilter,
        selectedTeamId,
        teamFilter,
        teamIdFromUrlParams,
        userIdFromUrlParams,
    ]);
    (0, react_1.useEffect)(() => {
        setTeamOptions(initialData.teams);
    }, [initialData.teams]);
    (0, react_1.useEffect)(() => {
        function fetchData() {
            const memberData = (0, walletHelper_1.buildTeamMemberOptions)({
                allMembersFromAllTeams: initialData.allMembersFromAllTeams,
                filterTeam,
                isUserCompanyAdminOrSupport,
            });
            setMemberOptions(memberData);
        }
        fetchData();
    }, [initialData.allMembersFromAllTeams, filterTeam, isUserCompanyAdminOrSupport]);
    (0, react_1.useEffect)(() => {
        if (teamFilter !== 'all') {
            void refetchTeamMembers();
        }
    }, [teamFilter]);
    const clearWalletCards = () => {
        setWalletCards([]);
    };
    (0, react_use_1.useShallowCompareEffect)(() => {
        if (paginatedWalletData.tasks?.length === 0) {
            setWalletCards([]);
        }
        else {
            setWalletCards(paginatedWalletData.tasks);
        }
        return clearWalletCards;
    }, [paginatedWalletData.tasks]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP &&
                globalThis.localStorage.getItem('hasUserSkipMfa') === 'true' ? ((0, jsx_runtime_1.jsxs)(material_1.Alert, { severity: "warning", variant: "filled", "ts-variant": "warning", style: { marginBottom: theme?.tsGoUnit.tsUnit }, children: [(0, jsx_runtime_1.jsx)("strong", { children: "Important Update: Enhance Your Security with 2FA" }), (0, jsx_runtime_1.jsx)("br", {}), "Starting 30th of March, 2025 Go will require two factor authentication to be used when accessing your account.", ' ', (0, jsx_runtime_1.jsx)("br", {}), "Set up 2FA now by clicking", ' ', (0, jsx_runtime_1.jsx)(material_1.Link, { onClick: async (e) => {
                            e.preventDefault();
                            try {
                                setHasUserSkipMfa(false);
                                await logout.mutateAsync();
                            }
                            catch (error) {
                                logger.error({ message: 'Error in logging out', error });
                            }
                            finally {
                                globalThis.location.href = '/signin/login';
                            }
                        }, style: {
                            color: 'inherit',
                            textDecorationColor: 'inherit',
                        }, href: "", children: "here" }), ' ', "to ensure uninterrupted access. Thank you for keeping your information secure! ", (0, jsx_runtime_1.jsx)("br", {}), "Need help? Contact us at:", ' ', (0, jsx_runtime_1.jsx)(material_1.Link, { href: "mailto:Go@Tradeshift.com", style: {
                            color: 'inherit',
                            textDecorationColor: 'inherit',
                        }, children: "Go@Tradeshift.com" })] })) : null, (0, jsx_runtime_1.jsxs)(walletContainer_1.default, { children: [(0, jsx_runtime_1.jsx)(headerActions_1.default, {}), cards?.length > 0 || cards?.length === 0 ? ((0, jsx_runtime_1.jsx)(StyledBox_1.StyledWalletContentBox, { children: isWalletDataFetching ? (isMyCardsView ? ((0, jsx_runtime_1.jsx)(cardsSkeletonLoader_1.default, { count: 6 })) : ((0, jsx_runtime_1.jsx)(TableLoader, {}))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isMyCardsView && ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(cardsSkeletonLoader_1.default, { count: 6 }), children: (0, jsx_runtime_1.jsx)(MyCardsListView, {}) })), isOtherWalletPagesView && ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(TableLoader, {}), children: (0, jsx_runtime_1.jsx)(AmexCardsListView, {}) }))] })) })) : isWalletDataFetching ? (isMyCardsView ? ((0, jsx_runtime_1.jsx)(cardsSkeletonLoader_1.default, { count: 6 })) : ((0, jsx_runtime_1.jsx)(TableLoader, {}))) : ((0, jsx_runtime_1.jsx)(emptyWallet_1.default, {}))] }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(WalletDetailAside, {}) })] }));
};
exports.default = WalletPage;
